module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-24GIU-25-small-9d27703d8bdd7a22f60f7d52335d005d.jpg";